import React, { FC } from 'react'
import { ChipPriorityProps, PriorityEnum } from './chipPriority.interface'
import { Chip } from '@mui/material'
import { styled } from "@mui/material/styles"
import { useTranslation } from "react-i18next"

export const CustomChip = styled(Chip)<{ customColor: string }>(({ theme, customColor }) => {
    const { backgroundColor, textColor } = getColor(customColor, theme);
    return {
        backgroundColor,
        color: textColor,
        fontWeight: '500',
    };
});


const getColor = (color: string, theme: any) => {
    switch (color) {
        case "primary":
            return {
                backgroundColor: theme.palette.sky[200],
                textColor: theme.palette.sky[900]
            };
        case "warning":
            return {
                backgroundColor: theme.palette.error.light,
                textColor: theme.palette.error[500]
            };
        case "error":
            return {
                backgroundColor: theme.palette.error.light,
                textColor: theme.palette.error[500]
            };
        case "info":
            return {
                backgroundColor: theme.palette.default.light,
                textColor: theme.palette.default.main
            }
        case "success":
            return {
                backgroundColor: theme.palette.green[200],
                textColor: theme.palette.success[700]
            }
        case "yellow":
            return {
                backgroundColor: theme.palette.warning.light,
                textColor: theme.palette.warning[500]
            };
        default:
            return {
                backgroundColor: theme.palette.default.light,
                textColor: theme.palette.default[900],
            };
    }
};

const ChipPriority: FC<ChipPriorityProps> = ({ type }) => {
    const { t } = useTranslation()

    switch (type) {
        case PriorityEnum.None:
            return (
                <CustomChip
                    customColor={"info"}
                    label={t("global.none", "None")}
                />
            )
        case PriorityEnum.Low:
            return (
                <CustomChip
                    customColor={"success"}
                    label={t("global.low", "Low")}
                />
            )
        case PriorityEnum.Medium:
            return (
                <CustomChip
                    customColor={"yellow"}
                    label={t("global.medium", "Medium")}
                />
            )
        case PriorityEnum.High:
            return (
                <CustomChip
                    customColor="warning"
                    label={t("global.high", "High")}
                />
            )
        case PriorityEnum.DrivingBan:
            return (
                <CustomChip
                    customColor="error"
                    label={t("vehicleregistry.driving_ban", "Driving ban")}
                />
            )
        default:
            return (
                <CustomChip
                    customColor={"info"}
                    label={t("global.none", "None")}
                />
            )
    }
}

export default ChipPriority